import * as THREE from 'three';
import { ElementRef, Injectable, NgZone, OnDestroy } from '@angular/core';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { BehaviorSubject } from 'rxjs';
import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib.js';

@Injectable({ providedIn: 'root' })
export class EngineService implements OnDestroy {
  controls: TrackballControls;
  dirLight: THREE.PointLight;
  renderer: THREE.WebGLRenderer;
  currentCameras = new BehaviorSubject<Array<{ name: string; id: string }>>([]);
  scene: THREE.Scene;
  private canvas: HTMLCanvasElement;
  private camera: THREE.PerspectiveCamera;
  private light: THREE.AmbientLight;
  private cube: THREE.Mesh;
  private frameId: number = null;
  private cameras: Record<string, any> = {};
  private mesh: THREE.Mesh;
  private lastUrl;

  public constructor(private ngZone: NgZone) {}

  public ngOnDestroy(): void {
    if (this.frameId != null) {
      cancelAnimationFrame(this.frameId);
    }
  }

  public createScene(canvas: ElementRef<HTMLCanvasElement>): void {
    // The first step is to get the reference of the canvas element from our HTML document
    this.canvas = canvas.nativeElement;

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      alpha: true, // transparent background
      antialias: true, // smooth edges,
      preserveDrawingBuffer: true,
    });
    this.renderer.shadowMap.type = THREE.VSMShadowMap;

    this.renderer.setSize(1920, 1920);
    // create the scene
    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      100
    );

    RectAreaLightUniformsLib.init();

    this.camera.position.z = 15;
    this.camera.position.x = 10;
    this.camera.position.y = 10;
    // this.camera.rotation.y = -.3;
    this.scene.add(this.camera);

    const light = new THREE.AmbientLight(0xf0f0f0); // soft white light
    light.intensity = 12.5;
    this.scene.add(light);
  }

  animate() {
    requestAnimationFrame(() => this.animate());

    this.controls.update();
    this.dirLight.position.set(
      this.camera.position.x + 10,
      this.camera.position.y + 10,
      this.camera.position.z + 10
    );
    this.render();
  }

  public render(): void {
    this.frameId = requestAnimationFrame(() => {
      // this.render();
    });

    const time1 = performance.now();
    this.renderer.render(this.scene, this.camera);

    const time2 = performance.now();
    const result = time2 - time1;
    console.log(result);
  }

  public resize(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(width, height);
  }

  loadModel(url) {
    const loader = new GLTFLoader();
    let cameraSet = false;
    this.scene.clear();
    this.cameras = {};
    const light = new THREE.AmbientLight(0xf0f0f0); // soft white light
    light.intensity = 0.5;
    this.scene.add(light);
    loader.load(url, (gltf) => {
      gltf.scene.traverse((object) => {
        if (object.type === 'PerspectiveCamera') {
          this.cameras[object.uuid] = object;
          if (!cameraSet) {
            // @ts-ignore
            this.camera = object;
            cameraSet = true;
          }
        }
        if (object.type === 'Mesh') {
          // @ts-ignore
          this.mesh = object;
          this.mesh.geometry.scale(1.004, 1.004, 1.004);
          const width =
            this.mesh.geometry.boundingBox.min.x +
            this.mesh.geometry.boundingBox.max.x;
          const height =
            this.mesh.geometry.boundingBox.min.y +
            this.mesh.geometry.boundingBox.max.y;
          const intensity = 0.5;
          const rectLight = new THREE.SpotLight(0xffffff, intensity);
          rectLight.position.set(
            -object.position.x - width * 4,
            object.position.y + height * 2.5,
            220
          );
          // this.camera.position.setZ(500);
          console.log(rectLight.position);
          if (rectLight.position.x < -1 && rectLight.position.x > -2) {
            rectLight.intensity = 0.05;
          }
          console.log(rectLight.position);

          this.scene.add(rectLight);
          // @ts-ignore
          // const rectLightHelper = new THREE.SpotLightHelper(rectLight);
          // this.scene.add(rectLightHelper);
          if (this.lastUrl) {
            this.loadTexture(this.lastUrl);
          }
        }
      });
      console.log(gltf);
      this.scene.add(gltf.scene);
      this.render();
    });
  }

  loadTexture(url) {
    this.lastUrl = url;
    const texture = new THREE.TextureLoader().load(url, () => {
      const mat = new THREE.MeshStandardMaterial({
        map: texture,
        // bumpMap:   new THREE.TextureLoader().load('/assets/noise.jpg'),
        // bumpScale: .005,
        bumpMap: new THREE.TextureLoader().load('/assets/noise3.jpg'),
        bumpScale: 0.1225,
        roughness: 0.6,
        metalness: 0.15,      });
      console.log(this.mesh);
      mat.map.flipY = false;
      this.mesh.material = mat;
      this.render();
    });
  }
}
